import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { combineLatest, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PhoneService {

  constructor() { }

  updatePlaceholders(phoneForm: FormGroup) {
    const DEFAULT_CALLER_NAME = 'Display Name';

    const displayName$ = phoneForm.get('displayName')
      ? phoneForm.get('displayName')!.valueChanges.pipe(
          startWith(phoneForm.get('displayName')!.value || ''),
          map((value) => value || DEFAULT_CALLER_NAME)
        )
      : of(DEFAULT_CALLER_NAME);

    const phoneNumber$ = phoneForm.get('phoneNumber')
      ? phoneForm.get('phoneNumber')!.valueChanges.pipe(
          startWith(phoneForm.get('phoneNumber')!.value || ''),
          map((value) => value || 'xxx xxx xxxx')
        )
      : of('xxx xxx xxxx');

    const countryCode$ = phoneForm.get('countryCodeVal')
      ? phoneForm.get('countryCodeVal')!.valueChanges.pipe(
          startWith(phoneForm.get('countryCodeVal')!.value || ''),
          map((value) => value || '')
        )
      : of('');

    return combineLatest([displayName$, phoneNumber$, countryCode$]).pipe(
      map(([displayName, phoneNumber, countryCode]) => {
        const formattedPhoneNumber = `${countryCode.replace(
          '+',
          ''
        )} ${phoneNumber}`.trim();
        return { displayName, formattedPhoneNumber };
      })
    );
  }
}
